<template>
  <div class="sc-header" :style="{background: colors.header.bg, color: colors.header.text}">
    <img class="sc-header--img" :src="imageUrl" alt="" v-if="imageUrl" />
    <div class="sc-header--title" @click="toggleUserList"> {{title}}
      <div v-if="option === 'companyChat'" class="circle" v-bind:class="[isOnline ? online : offline ]">
      </div>
    </div>
    <div class="sc-header--close-button" @click="onClose">
      <i v-if="option === 'companyChat' || option === 'companyGroupChat'" class="el-icon-back"></i>
      <i v-else class="el-icon-close"></i>
    </div>
    <div v-if="option === 'companyChat' || option === 'companyGroupChat'" class="sc-header--close-button" @click="onCloseAll">
      <img src="./assets/close-icon.png" alt="">
    </div>
  </div>
</template>
<script>

export default {
  props: {
    isOnline: {
      type: Boolean,
      required: true
    },
    imageUrl: {
      type: String,
      required: true
    },
    title: {
      type: String
    },
    option: {
      type: String
    },
    onClose: {
      type: Function,
      required: true
    },
    onCloseAll: {
      type: Function,
      required: true
    },
    colors: {
      type: Object,
      required: true
    }
  },
  methods: {
    toggleUserList() {
      this.inUserList = !this.inUserList
      this.$emit("userList", this.inUserList)
    }
  },
  data() {
    return {
      online: 'online',
      offline: 'offline',
      inUserList: false
    }
  }
}
</script>
<style lang="less" scoped>
.sc-header {
  min-height: 75px;
  border-top-left-radius: 9px;
  border-top-right-radius: 9px;
  padding: 10px;
  box-shadow: 0 1px 4px rgba(0,0,0,.2);
  position: relative;
  box-sizing: border-box;
  display: flex;
}

.sc-header--img {
  border-radius: 50%;
  align-self: center;
  padding: 10px;
}

.sc-header--title {
  justify-content: space-between;
  align-self: center;
  padding: 10px;
  flex: 1;
  user-select: none;
  cursor: pointer;
  border-radius: 5px;
  display: flex;
  align-items: center;
}

.sc-header--title:hover {
  box-shadow: 0px 2px 5px rgba(0.2, 0.2, 0.5, .1);
}

.sc-header--close-button {
  display:flex;
  align-items:center;
  justify-content:center;
  width: 30px;
  align-self: center;
  height: 30px;
  margin-right: 10px;
  box-sizing: border-box;
  cursor: pointer;
  border-radius: 5px;
  .el-icon-back{
    font-size:18px;
  }
}

.sc-header--close-button:hover {
  box-shadow: 0px 2px 5px rgba(0.2, 0.2, 0.5, .1);
}

.sc-header--close-button img {
  width: 100%;
  height: 100%;
  padding: 8px;
  box-sizing: border-box;
}

.circle{
  min-height:15px;
  min-width:15px;
  border-radius:50%;
  &.online{
     background-color:#67C23A;
   }
  &.offline{
    background-color: #F56C6C;
  }
}
@media (max-width: 450px) {
  .sc-header {
    border-radius: 0px;
  }
}
</style>
